import { isUserTypeIsKAM } from 'dedicated/components/plan-and-configuration/configure-plan-pricing-constant';
import { MODULE_ID } from '../../home/common/constants/constants';
import { getFromSessionStorage, findParamFromUrl, isNull } from '../utils/app.utils';
import { getCurrentLead, getCurrentOrder } from 'tokenGeneration/lead.util';
import { ERROR_TOAST, SUCCESS_TOAST, WARNING_TOAST } from 'home/view/manage-feasibility/constants';
import { CLICK_TYPE } from 'featureLib';
import classNames from 'classnames';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';
// import { SESSION_STORAGE } from 'home/view/upgrade-order/constants';

export const Base_Href = process.env.REACT_APP_BASE_HREF || '';
export const PRODUCT_NAME = 'productName';
export const VPN_CONFIG = {
  PRIMARY_LAN_IP: 'PRIMARY_LAN_IP',
  PRIMARY_WAN_IP: 'PRIMARY_WAN_IP',
  SECONDARY_LAN_IP: 'SECONDARY_LAN_IP',
  SECONDARY_WAN_IP: 'SECONDARY_WAN_IP'
};
export const APP_NAME = 'dedicated-internet-ui';

export const DEDICATED_JOURNEY_PATH = 'internet-leased-line';

export const JOURNEY_TYPE = {
  BULK_UPGRADE: 'bulk-upgrade',
  SHIFTING: 'shifting',
  SINGLE_UPGRADE_SHIFTING: 'single-upgrade-shifting'
};

export const ROUTES = {
  B2B_HOME: '/broadband-internet',
  B2B_CHECK_FEASIBILITY: '/broadband-internet/check-feasibility',
  B2B_CHOOSE_PLAN: '/broadband-internet/choose-plan',
  WEB_VIEW: '/broadband-internet/app',
  B2B_THANK_YOU: '/broadband-internet/thank-you',
  B2B_SUMMARY: '/broadband-internet/summary',

  B2B_FOUR_ZERO: '/broadband-internet/404',
  UNAUTH_HOME: '/',
  DEDICATED_URL: '/acquisition',
  DEDICATED_HOME: '/acquisition/check-feasibility-auth',
  DEDICATED_CHECK_FEASIBILITY: '/acquisition/check-feasibility',
  DEDICATED_CHOOSE_PLAN: '/acquisition/choose-plan',
  DEDICATED_THANK_YOU: '/acquisition/thank-you',
  DEDICATED_QUOTATION: '/acquisition/quotation',
  DEDICATED_CANCEL: '/acquisition/cancel',
  DEDICATED_SUMMARY: '/acquisition/summary',
  CONFIRM_INSTALLATION: '/acquisition/confirm-installation',
  B2B_FAILURE: '/acquisition/failure',
  B2B_SUCCESS: '/acquisition/success',
  DEDICATED_BULK_FEASIBILITY: '/acquisition/bulk-feasibility',
  MULTI_SITE_PLAN_PRICING: '/acquisition/multi/plan-pricing',
  DEDICATED_ORDER_SUMMARY: '/acquisition/order-summary',
  TRACK_ORDER: '/track-order',
  ERROR_PAGE: '/acquisition/error',
  RATE_CARD: '/acquisition/rate-card',
  UPGRADE_ORDER: '/acquisition/upgrade-order',
  AOI: {
    DEDICATED_HOME: '/acquisition/check-feasibility-aoi',
    DEDICATED_BULK_FEASIBILITY: '/acquisition/bulk-feasibility-aoi',
    MULTI_SITE_PLAN_PRICING: '/acquisition/multi/plan-pricing-aoi',
    DEDICATED_ORDER_SUMMARY: '/acquisition/order-summary-aoi',
    TRACK_ORDER_AOI: '/acquisition/track-order-aoi'
  },
  EXPRESS_DELIVERY_PAGE_LOGIN: '/acquisition/express-delivery/login',
  EXPRESS_DELIVERY_PAGE_ORDER: '/acquisition/express-delivery/order-details',
  FEATURE_LIB: {
    PURCHASE_ORDER: '/purchase-order',
    ORDER_DETAILS: '/order-details',
    INSTALLATION_DETAILS: '/installation-details',
    MULTI_SELECT: '/multi-select'
  }
};

export const LOB = {
  DATA: 'DATA',
  MOBILITY: 'MOBILITY'
};
export const NOTIFICATION_TIMEOUT = 10;
export const META_TAGS = {
  AOI_CHECK_FEASIBLITY: {
    title: 'Business Broadband - Airtel Office Internet Plans for Enterprise',
    desc: "Buy Broadband Internet for Business – Get work done faster with high speed Airtel broadband Internet. It has Superior indoor coverage with Wi-Fi calling, quick activation, service delivery and more.",
    keywords: 'Airtel Office Internet, AOI, high speed internet, Airtel ILL, airtel leased line, airtel internet, secure internet',
    canonical: 'https://www.airtel.in/business/b2b/internet-leased-line/'
  },
  B2B_HOME: {
    title: 'Internet Leased Line: High-Speed Dedicated Internet Connection for Business',
    desc: "Experience unmatched connectivity with Airtel Leased Line services. Discover the power of Airtel's reliable and high-speed dedicated internet leased line solutions for businesses.",
    keywords: 'internet leased line, ILL, high speed internet, Airtel ILL, airtel leased line, airtel internet, secure internet',
    canonical: 'https://www.airtel.in/business/b2b/internet-leased-line/'
  },
  B2B_CHECK_FEASIBILITY: {
    title: 'Internet Leased Line: High-Speed Dedicated Internet Connection for Business',
    desc: "Experience unmatched connectivity with Airtel Leased Line services. Discover the power of Airtel's reliable and high-speed dedicated internet leased line solutions for businesses.",
    keywords: 'internet leased line, ILL, high speed internet, Airtel ILL, airtel leased line, airtel internet, secure internet',
    canonical: 'https://www.airtel.in/business/b2b/internet-leased-line/check-feasibility'
  },
  B2B_CHOOSE_PLAN: {
    title: 'Internet Leased Line: High-Speed Dedicated Internet Connection for Business',
    desc: 'Get high-speed Airtel Dedicated Internet connection with maximum security, 99.5% uptime and low cost plans. Accelerate your business with always on internet.',
    keywords: 'internet leased line, ILL, high speed internet, Airtel ILL, airtel leased line, airtel internet, secure internet',
    canonical: 'https://www.airtel.in/business/b2b/internet-leased-line/choose-plan'
  },
  B2B_THANK_YOU: {
    title: 'Internet Leased Line: High-Speed Dedicated Internet Connection for Business',
    desc: 'Get high-speed Airtel Dedicated Internet connection with maximum security, 99.5% uptime and low cost plans. Accelerate your business with always on internet. ',
    keywords: 'internet leased line, ILL, high speed internet, Airtel ILL, airtel leased line, airtel internet, secure internet',
    canonical: 'https://www.airtel.in/business/b2b/internet-leased-line/thank-you'
  },
  B2B_SUMMARY: {
    title: 'Internet Leased Line: High-Speed Dedicated Internet Connection for Business',
    desc: 'Get high-speed Airtel Dedicated Internet connection with maximum security, 99.5% uptime and low cost plans. Accelerate your business with always on internet. ',
    keywords: 'internet leased line, ILL, high speed internet, Airtel ILL, airtel leased line, airtel internet, secure internet',
    canonical: 'https://www.airtel.in/business/b2b/internet-leased-line/summary'
  },
  B2B_FOUR_ZERO: {
    title: 'Internet Leased Line: High-Speed Dedicated Internet Connection for Business',
    desc: 'Get high-speed Airtel Dedicated Internet connection with maximum security, 99.5% uptime and low cost plans. Accelerate your business with always on internet. ',
    keywords: 'internet leased line, ILL, high speed internet, Airtel ILL, airtel leased line, airtel internet, secure internet',
    canonical: 'https://www.airtel.in/business/b2b/internet-leased-line'
  },
  B2B_PRICING_QUOTATION: {
    TITLE: {
      UPGRADE: 'Upgrade Order Request'
    }
  }
};
export const CONSTANTDATA = {
  LOAD_ITEM: 10,
  PAGE_LIMIT: 10
};

export const COMMON_API_HEADERS = {
  // 'iv-user': 'test@gmail.com',
  'Content-Type': 'application/json'
};

export const PNQ_API_HEADERS = {
  // 'iv-user': 'pramod5.kumar@airtel.com',
  'Content-Type': 'application/json'
};
export const LEAD_API_HEADERS = {
  // 'iv-user': 'test@gmail.com',
  'Content-Type': 'application/json'
};
export const LEAD_API_HEADERS_DEV = {
  //'iv-user': 'test@gmail.com',
  'Content-Type': 'application/json'
};
export const COMMON_PARAMS = {
  serviceType: 'DEDICATED_INTERNET'
};
export const PRODUCT_TYPE = {
  VPN: 'VPN',
  DEDICATED_INTERNET: 'DEDICATED_INTERNET',
  NLD: 'NLD',
  LL: 'LL',
  DSL: 'DSL'
};

export const SERVICE_TYPE = {
  NLD: 'Direct VPN',
  LL: 'Local Loop',
  DEDICATED_INTERNET: 'Dedicated Internet',
  VPN: 'VPN'
};

export const DEDICATED_COMMON_PARAMS = {
  serviceType: getFromSessionStorage?.(MODULE_ID, PRODUCT_NAME) ? getFromSessionStorage?.(MODULE_ID, PRODUCT_NAME) : 'DEDICATED_INTERNET'
};

export const MOENGAGE_ANALYTICS_EVENT = {
  CHECK_FEASIBILITY_PAGE_VISIT: 'ACQ_AUTH_DI_CHK_FEASIB_PG_VISIT',
  CHECK_FEASIBILITY_BUY_NOW: 'ACQ_AUTH_DI_CHK_FEASIB_BUY_NOW',
  UNAUTH_CHECK_FEASIBILITY_PAGE_VISIT: 'ACQ_UNAUTH_DI_CHK_FEASIB_PG_VISIT',
  UNAUTH_CHECK_FEASIBILITY_BUY_NOW: 'ACQ_UNAUTH_DI_CHK_FEASIB_BUY_NOW',
  SUBMIT_CUSTOMER_DEATILS: 'ACQ_AUTH_DI_SUBMIT_CUST_DETAILS',
  SUBMIT_FEASIBILITY: 'ACQ_AUTH_DI_SUBMIT_FEASIB',
  UNAUTH_SUBMIT_CUSTOMER_DEATILS: 'ACQ_UNAUTH_DI_SUBMIT_CUST_DETAILS',
  UNAUTH_SUBMIT_FEASIBILITY: 'ACQ_UNAUTH_DI_SUBMIT_FEASIB',
  AUTH_PLAN_PAGE_VISIT: 'ACQ_AUTH_DI_PLAN_PG_VISIT',
  UNAUTH_PLAN_PAGE_VISIT: 'ACQ_UNAUTH_DI_PLAN_PG_VISIT',
  AUTH_SUBMIT_PLAN: 'ACQ_AUTH_DI_SUBMIT_PLAN',
  UNAUTH_SUBMIT_PLAN: 'ACQ_UNAUTH_DI_SUBMIT_PLAN',
  AUTH_THANK_YOU_PAGE_VISIT: 'ACQ_AUTH_DI_THANK_YOU_PG_VISIT',
  UNAUTH_THANK_YOU_PAGE_VISIT: 'ACQ_UNAUTH_DI_THANK_YOU_PG_VISIT',
  THANK_YOU_PAGE_REFER_A_BUSINESS: 'ACQ_DI_REFER_A_BUSINESS'
};

export const IPV4_MAX_VALUE = 32;
export const IPV4_MAX_LIMIT = 29;
export const IP_SPEC_PREFIX = 'ip_';
export const IP_KEYS = {
  IP_VERSION: 'ipVersion',
  ROUTING_PROTOCOL: 'routingProtocol',
  IP_TYPE: 'ipType',
  IP_SUBNET: 'ipSubnet',
  NO_OF_LAN: 'noOfLAN',
  NO_OF_WAN: 'noOfWAN',
  TOTAL_IP: 'totalIP',
  LAN_IP_SUBNET: 'lanIPSubnet',
  WAN_IP_SUBNET: 'wanIPSubnet',
  LAN_IP_V6_SUBNET: 'lanIPV6Subnet',
  WAN_IP_V6_SUBNET: 'wanIPV6Subnet',
  TOTAL_IP_EXCEEDED: 'totalIpExceeded'
};

export const IP_LABEL = {
  ipVersion: 'IP Versions',
  routingProtocol: 'Routing Protocol',
  ipType: 'IP Type',
  ipSubnet: 'Subnet',
  noOfLAN: 'Number of LAN',
  noOfWAN: 'Number of WAN',
  totalIP: 'Total IP',
  lanIPSubnet: 'LAN IPV4 Subnet',
  wanIPSubnet: 'WAN IPV4 Subnet',
  lanIPV6Subnet: 'LAN IPV6 Subnet',
  wanIPV6Subnet: 'WAN IPV6 Subnet'
};

export const IP_ROUTING_MAPPING = {
  None: { displayName: 'Only Wan', key: 'Only Wan' },
  Static: { displayName: 'Lan and Wan', key: 'Lan and Wan' },
  'Private BGP': { displayName: 'Lan and Wan', key: 'Lan and Wan' },
  'Public BGP': { displayName: 'Only Wan', key: 'Only Wan' },
  BGP: { displayName: 'Lan and Wan', key: 'Lan and Wan' },
  Both: { displayName: 'Lan and Wan', key: 'Lan and Wan' },
  'Static with Private BGP': { displayName: 'Lan and Wan', key: 'Lan and Wan' },
  'Static with Public BGP': { displayName: 'Lan and Wan', key: 'Lan and Wan' }
};

export const IP_SPEC_NAME = {
  ipVersion: 'ipVersion',
  routingProtocol: 'routingProtocol',
  ipType: 'ipType',
  ipSubnet: 'ipSubNet',
  noOfLAN: 'noOfLAN',
  noOfWAN: 'noOfWAN',
  totalIP: 'totalIp',
  lanIPSubnet: 'lanIPSubnet',
  wanIPSubnet: 'wanIPSubnet',
  lanIPV6Subnet: 'lanIPV6Subnet',
  wanIPV6Subnet: 'wanIPV6Subnet'
};

export const DEFAULT_IP_DETAIL = {
  [IP_KEYS.IP_VERSION]: { displayName: '', key: '' },
  [IP_KEYS.ROUTING_PROTOCOL]: { displayName: '', key: '' },
  [IP_KEYS.IP_TYPE]: { displayName: '', key: '' },
  [IP_KEYS.IP_SUBNET]: {}
};

export const SPEC_DETAIL = { name: '', value: '', description: '' };
export const LAN_WAN_DEFAULT_DETAILS = {
  [IP_KEYS.NO_OF_LAN]: 1,
  [IP_KEYS.NO_OF_WAN]: 2,
  [IP_KEYS.TOTAL_IP]: '',
  [IP_KEYS.TOTAL_IP_EXCEEDED]: false
};

export const CART_ID = 'cartId';
export const AUTH_TOKEN_PLAN_PRICING = 'auth_pricing';
export const USER_TYPE = 'user_type';
export const USER_TYPE_KAM = 'KAM';

export const contractPeriodOptions = [
  { key: '1', displayName: '1 Year', value: 1 },
  { key: '2', displayName: '2 Years', value: 2 },
  { key: '3', displayName: '3 Years', value: 3 },
  { key: '4', displayName: '4 Years', value: 4 },
  { key: '5', displayName: '5 Years', value: 5 }
];

export const preOrderPeriodOptions = [
  { key: '30', displayName: '30 days', value: 30 },
  { key: '60', displayName: '60 days', value: 60 },
  { key: '90', displayName: '90 days', value: 90 }
];

export const GENERIC_ERROR_MESSAGE = 'An unexpected error has occurred. Our technical staff has been automatically notified and will be looking into this with utmost urgency.';
export const ORDER_TYPE = {
  ORDER_CONFIRMATION: 'ORDER_CONFIRMATION',
  ORDER_CONFIRMATION_PENDING: 'ORDER_CONFIRMATION_PENDING',
  ORDER_SUBMITTED: 'ORDER_SUBMITTED',
  ORDER_CONFIRMED: 'ORDER_CONFIRMED',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  ORDER_IN_PROGRESS: 'ORDER_IN_PROGRESS',
  OV_REJECTED: 'OV_REJECTED'
};

export const SERVICE_NAME = {
  Vpn: 'VPN',
  'Dedicated Internet': 'Dedicated Internet'
};

export const getProductType = (isProductAlias = false) => {
  const productType = DEDICATED_COMMON_PARAMS?.serviceType?.toUpperCase();
  const productAlias = {
    DEDICATED_INTERNET: 'INTERNET',
    VPN: 'MPLS',
    NLD: 'NLD',
    LL: 'LL',
    DSL: 'DSL'
  };

  return isUserTypeIsKAM() || isProductAlias ? productAlias[productType] : productType;
};

export const isRateCardJourney = () => {
  return isUserTypeIsKAM() && window?.location?.pathname?.includes('rate-card');
};

export const isNLD_OR_LL = () => {
  const productType = getProductType();
  return productType === PRODUCT_TYPE.NLD || productType === PRODUCT_TYPE.LL;
};

export const isVPN_OR_DI = () => {
  const productType = getProductType();
  return productType === PRODUCT_TYPE.VPN || productType === PRODUCT_TYPE.DEDICATED_INTERNET;
};

export const isVPN = () => {
  const productType = getProductType();
  return productType === PRODUCT_TYPE.VPN;
};

export const isBulkUpgrade = () => {
  const activeLead = getCurrentLead();
  const orderType = activeLead?.orderType ?? null;
  const orderSubType = activeLead?.orderSubType ?? null;
  const journeyTypeFromParam = findParamFromUrl('journey', false);
  if (journeyTypeFromParam && journeyTypeFromParam === JOURNEY_TYPE.BULK_UPGRADE) {
    return true;
  }
  return (orderType && orderType === 'CHANGE_ORDER') || (orderType === 'PRE_ORDER' && orderSubType === TYPEOF_ORDER.UPGRADE);
};

export const isBulkPreOrderUpgrade = () => {
  const activeLead = getCurrentLead();
  const orderType = activeLead?.orderType ?? null;
  const orderSubType = activeLead?.orderSubType ?? null;

  return orderType === 'PRE_ORDER' && orderSubType === TYPEOF_ORDER.UPGRADE;
};

export const isPreOrder = () => {
  const activeLead = getCurrentLead();
  const orderType = activeLead?.orderType ?? null;
  const orderSubType = activeLead?.orderSubType ?? null;

  return orderType === 'PRE_ORDER' && (orderSubType === TYPEOF_ORDER.NEW || orderSubType === TYPEOF_ORDER.UPGRADE);
};

export const isAOILandingPage = () => {
  return window?.location?.pathname?.includes(ROUTES.AOI.DEDICATED_HOME) ?? false;
};

export const isAOIOrder = () => {
  let activeLead = getCurrentLead();
  let getorderType=getFromSessionStorage(MODULE_ID,"JOURNEY_TYPE");
  let getProductName=getFromSessionStorage(MODULE_ID,"productName");
  let orderType = null;
  let productName = null;
  if (!activeLead) {
    activeLead = getCurrentOrder();
  }
  orderType = activeLead?.orderType ?? 'NEW';
  productName = activeLead?.serviceType ?? getProductName;

  // const leadIdFromParam = findParamFromUrl('leadId', false);
  // const cartIdFromParam = findParamFromUrl('cartId', false);
  // const isTMO = findParamFromUrl('journey', false) === 'trackLead';
  // const isTMORedirect = (leadIdFromParam || cartIdFromParam) && isTMO;

  return isAOILandingPage() || (orderType === 'NEW' && productName === 'DSL');
};

export const isLoiAvailable = () => {
  const activeLead = getCurrentLead();
  const loiAvailable = activeLead?.loiAvailable || false;
  return isPreOrder() && loiAvailable;
};

export const isShiftingJourney = () => {
  const activeLead = getCurrentLead?.();
  // const activeOrder = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.ORDER_DETAILS);
  // const orderType = activeLead?.orderType ?? activeOrder?.orderType ?? null;
  // const orderSubType = activeLead?.orderSubType ?? activeOrder?.orderSubType ?? null;
  const orderType = activeLead?.orderType ?? null;
  const orderSubType = activeLead?.orderSubType ?? null;
  const journeyTypeFromParam = findParamFromUrl('journey', false);
  if (journeyTypeFromParam === JOURNEY_TYPE.SHIFTING) {
    return true;
  }

  return orderType === 'CHANGE_ORDER' && orderSubType === TYPEOF_ORDER.SHIFTING;
};

export const isAppointmentJourney = () => {
  const activeLead = getCurrentLead?.();
  const activeOrder = getCurrentOrder?.();

  const serviceType = activeLead?.serviceType || activeOrder?.serviceType || null;
  const orderType = activeLead?.orderType || activeOrder?.orderType || null;
  const orderSubType = activeLead?.orderSubType || activeOrder?.orderSubType || null;

  /**
   * ENABLE OTHER PRODUCTS FOR APPOINTMENT JOURNEYS via serviceType
   */
  return orderType === TYPEOF_ORDER.NEW && orderSubType === TYPEOF_ORDER.NEW && serviceType === PRODUCT_TYPE.DEDICATED_INTERNET;
};

export const isOrderConfirmationPending = () => {
  const activeOrder = getCurrentOrder?.();
  const orderStatus = activeOrder?.orderStatus;

  const isOrderConfirmationPending = (orderStatus && [ORDER_TYPE.ORDER_CONFIRMATION, ORDER_TYPE.ORDER_CONFIRMATION_PENDING]).includes(orderStatus) || isOrderConfirmationUrl();
  return isOrderConfirmationPending;
};

export const STORAGE_KEY = {
  JOURNEY_TYPE: 'JOURNEY_TYPE'
};

export const getProductDisplayName = (product) => {
  const displayMap = {
    [PRODUCT_TYPE.DEDICATED_INTERNET]: 'Dedicated Internet',
    [PRODUCT_TYPE.VPN]: 'VPN',
    [PRODUCT_TYPE.NLD]: 'NLD (Direct VPN)',
    [PRODUCT_TYPE.LL]: 'LL',
    [PRODUCT_TYPE.DSL]: 'Airtel Office Internet'
  };
  return displayMap[product] ? displayMap[product] : '-';
};

export const getSummaryProductDisplayName = (product) => {
  const displayMap = {
    [PRODUCT_TYPE.DEDICATED_INTERNET]: 'Dedicated Internet (ILL)',
    [PRODUCT_TYPE.VPN]: 'VPN (MPLS)',
    [PRODUCT_TYPE.NLD]: 'NLD (Direct VPN)',
    [PRODUCT_TYPE.LL]: 'LL'
  };
  return displayMap[product] ? displayMap[product] : '-';
};

export const VPN_SITE_TYPE = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
};

export const FEASIBILITY_EXPIRED_DAYS = 45;
export const MULTI_SITE_STEPS = {
  SUBMIT_ORDER_DETAILS: 'Add Order Details',
  FEASIBILITY_CHECK: 'Check Site Feasibility',
  PLAN_CONFIGURATION: 'Plan & Configuration',
  CONFIRM_ORDER_DETAILS: 'Enter Billing Details',
  CONFIRM_INSTALLATION: 'Confirm Installation'
};

export const MULTI_SITE_AOI_STEPS = {
  ACCOUNT_DETAILS: 'Account details',
  FEASIBILITY: 'Feasibility',
  BILLING_AND_PRICING: 'Billing and pricing',
  KYC: 'KYC'
};

export const ACCORDION_VARIANTS = {
  ROUND: 'round',
  COMPACT: 'compact',
  ARROW_WITH_TEXT: 'arrow_with_text'
};

export const PLAN_PAGE_NOTIFICATIONS = {
  DEFAULT: 'Our team would contact you post doing a network availability check within 24hrs. For any queries, write to us at airtelforbusiness@airtel.com',
  MANUAL_CHECK: 'Manual network check is required for this location. Please note that the bandwidth range may differ after the feasibility result.'
};

export const PRODUCT_ALIAS_MAP = {
  DEDICATED_INTERNET: 'ILL',
  VPN: 'MPLS',
  NLD: 'NLD',
  LL: 'LL',
  DSL: 'DSL'
};

export const TYPEOF_ORDER = {
  NEW: 'NEW',
  UPGRADE: 'UPGRADE',
  SHIFTING: 'SHIFTING',
  NEW_PRE_ORDER: 'NEW_PRE_ORDER',
  UPGRADE_PRE_ORDER: 'UPGRADE_PRE_ORDER'
};

export const CUSTOMER_SEGMENT = {
  ENTERPRISE: 'AB',
  SMB: 'CHANNEL'
};

export const CIRCLE_WISE = true;

export const MAX_RETRY_COUNT = 3;

export const ORDER_SUBMITTED_POST_STATUS = ['OV_', 'iB2B_', 'CAF_'];

export const PO_MAX_YEAR_BACK = 10;

export const LSI_ERRORS = {
  DEFAULT_MSG: 'Invalid circuit ID',
  PARTY_MISMATCH: 'Circuit ID does not belong to the account',
  PRODUCT_MISMATCH: 'Circuit ID does not belong to the product type'
};

export const ROUTERS = {
  STANDARD: 'STANDARD',
  NON_STANDARD: 'NON_STANDARD'
};

export const FEASIBILITY_STATUS_ENUM = {
  FEASIBLE: 'FEASIBLE',
  MANUAL_INTERVENTION_REQUIRED: 'MANUAL_INTERVENTION_REQUIRED',
  FAILED_4G: 'ERROR_OCCURRED'
};

const tranformSitesText = (sites) => {
  if (sites === 1) {
    return isNLD_OR_LL() ? 'link' : 'site';
  }

  return isNLD_OR_LL() ? 'links' : 'sites';
};

const isAreTransformer = (sites) => {
  if (sites === 1) {
    return 'is';
  }

  return 'are';
};

export const THROTTLE_TIMEOUT_4G = 10000; // 10 sec

export const get4gFailureMessage = ({ feasibilityStatusMap, totalElement, throttled4gRetry }) => {
  const failed4gCount = feasibilityStatusMap[FEASIBILITY_STATUS_ENUM.FAILED_4G];
  const manualCount = feasibilityStatusMap[FEASIBILITY_STATUS_ENUM.MANUAL_INTERVENTION_REQUIRED];
  const feasibleCount = feasibilityStatusMap[FEASIBILITY_STATUS_ENUM.FEASIBLE];
  const retry_cta_id = 'retry_cta';

  const handleRetryClick = () => {
    throttled4gRetry?.();

    // disable CTA for 10 sec.
    document.getElementById(retry_cta_id).classList.add('disabled');
    setTimeout(() => {
      document.getElementById(retry_cta_id).classList.remove('disabled');
    }, 10000);
  };

  if (isBulkUpgrade()) {
    const isAllManual = manualCount === totalElement;

    const toastMsg = isAllManual
      ? ` All sites processed, ${manualCount} ${tranformSitesText(manualCount)} require manual network check. Our team will contact you. `
      : ` All sites processed, ${manualCount} ${tranformSitesText(manualCount)} require manual network check. ${
          feasibleCount > 0 ? `You can proceed with ${feasibleCount} feasible ${tranformSitesText(feasibleCount)}.` : ''
        } Our team will contact you. `;

    return {
      infoMsg: toastMsg,
      infoType: WARNING_TOAST
    };
  }

  return {
    infoMsg: (
      <div>
        {totalElement > 0 && feasibleCount > 0 && (
          <span>{`${totalElement} ${tranformSitesText(totalElement)} checked. ${feasibleCount} ${tranformSitesText(feasibleCount)} found feasible.`}</span>
        )}
        {failed4gCount > 0 && (
          <>
            <br />
            <span>
              {`${failed4gCount} ${tranformSitesText(failed4gCount)} ${isAreTransformer(failed4gCount)} not 4G/5G feasible.`}{' '}
              <u
                id={retry_cta_id}
                dataType={CLICK_TYPE.LINK}
                className={classNames({
                  link_cta: true
                })}
                style={{
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
                onClick={handleRetryClick}
              >
                Retry Feasibility Check
              </u>
            </span>
          </>
        )}
        {manualCount > 0 && (
          <>
            <br />
            <span>{`${manualCount} ${tranformSitesText(manualCount)} will require manual network check. Our team will contact you with more information in the next 24 hrs.`}</span>
          </>
        )}
      </div>
    ),
    infoType: failed4gCount > 0 ? ERROR_TOAST : manualCount > 0 ? WARNING_TOAST : SUCCESS_TOAST
  };
};
export const FILE_MAX_SIZE = 5120 * 1024;
export const FILE_MAX_SIZE_MSG = 'Maximum file size is ' + FILE_MAX_SIZE / 1024 / 1024 + ' Mb';
